var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34303 3.20206C2.78374 3.17058 3.16652 3.50232 3.19799 3.94303L3.94492 14.4L12.0551 14.4L12.802 3.94303C12.8335 3.50232 13.2163 3.17058 13.657 3.20206C14.0977 3.23354 14.4295 3.61632 14.398 4.05702L13.651 14.514C13.5912 15.3513 12.8945 16 12.0551 16H3.94492C3.1055 16 2.4088 15.3513 2.34899 14.514L1.60206 4.05702C1.57059 3.61632 1.90233 3.23354 2.34303 3.20206Z",
    fill: "#B93F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.99999C0 3.55816 0.358171 3.19999 0.799998 3.19999H15.2C15.6418 3.19999 16 3.55816 16 3.99999C16 4.44182 15.6418 4.79999 15.2 4.79999H0.799998C0.358171 4.79999 0 4.44182 0 3.99999Z",
    fill: "#B93F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 1.6C3.99999 0.716343 4.71633 0 5.59999 0H10.4C11.2836 0 12 0.716343 12 1.6V3.19999C12 3.64182 11.6418 3.99999 11.2 3.99999C10.7582 3.99999 10.4 3.64182 10.4 3.19999V1.6H5.59999V3.19999C5.59999 3.64182 5.24182 3.99999 4.79999 3.99999C4.35816 3.99999 3.99999 3.64182 3.99999 3.19999V1.6Z",
    fill: "#B93F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.dc8c6bd426701303ab09e15b97e0a640.svg";
export { ForwardRef as ReactComponent };